import React from 'react'
import {
    AllEvents,
    CardItem,
    createCardClickedEvent,
    PublicationCardItem,
} from '@news-mono/web-common'
import { MaybeLoaded } from '@west-australian-newspapers/json-react-layouts-data-loader'
import { colorsPN, metricsPN } from '@news-mono/design-tokens'
import { getFundingType } from '../../../../../templates'
import { Romeo } from '../../../../../collections/PNRomeo/Romeo'

export interface PNInlinerelatedContentProps {
    items: PublicationCardItem[]
    onEvent: (event: AllEvents) => void
    publicationPath?: string
    publicationKind?: string
    isV2ArticlePageEnabled?: boolean
}

export const PNInlineRelatedContent: React.FC<PNInlinerelatedContentProps> = ({
    items,
    onEvent,
}) => {
    const storyClassification = true

    function linkClicked(
        e: React.MouseEvent<HTMLElement>,
        item: MaybeLoaded<CardItem>,
        cardNumber: number,
    ) {
        if (
            !item.loaded ||
            item.result.cardType === 'marketing-redirect-tile'
        ) {
            e.preventDefault()
            return
        }
        onEvent(
            createCardClickedEvent(
                onEvent,
                item.result,
                'PerthNowInlineRelatedContentCards',
                'InlineRelatedContent',
                cardNumber,
                getFundingType(item.result, storyClassification),
                'InlineRelatedCollection',
            ),
        )
    }

    return (
        <Romeo
            itemClickEventHandler={linkClicked}
            items={{ loaded: true, result: items }}
            expectedCards={items.length}
            hideByline={true}
            marginBottom={metricsPN.spacing['L']}
            hideCardFooter={true}
            horizontalDividerColor={colorsPN.stroke.weak}
            fixedRatios={'4:3'}
            cardSpacing={16}
            onEvent={onEvent}
            hideTopDivider={false}
            hideLastDivider={false}
            topBottomDividerColorOverride={colorsPN.stroke.brand.solid}
            fontScale={'M'}
            headerFontScale={'M'}
            headerFontOverride={{
                mobile: '2XS',
                tablet: 'XS',
                desktop: 'M',
            }}
            imageSizeOverride={{
                mobile: '2XS',
                tablet: '2XS',
                desktop: 'M',
            }}
            impressionEventInfo={{
                collectionName: 'InlineRelatedContent',
                overrides: {
                    componentType: 'inlinerelatedcontent',
                },
            }}
        />
    )
}
